import { formatClockTime, formatDate } from "shared/utils";

// ISO8601 UTC с бэка → "ММ/ДД/ГГ ЧЧ:ММ" в локальном времени.
export const formatRaffleDate = (iso: string): string => {
  const timestamp = Date.parse(iso);
  return `${formatDate(timestamp)} ${formatClockTime(timestamp)}`;
};
